// extracted by mini-css-extract-plugin
export default {"account_cart_section_mob":"RM","account_cart_no_carousel":"SM","carousel":"TM","carouselwide":"UM","carouselwrapper":"VM"};
    if(module.hot) {
      // 1737143662456
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  